import { PlusCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  message,
  Divider,
  TreeSelect,
  Spin,
  Select,
} from "antd";
import React, { useState, useEffect } from "react";
import { store } from "../../../redux/configStore";
import {
  getListTrademark,
  createTrademark
} from "../../../api/Trademark/Trademark";
import { loadAllUser } from "../../../auth/session";
import { getDisplayNameFromUser } from "../../../utils/userDisplayName";
import { useSession } from "../../../auth/session";

export default function FormAddTrademark({
  isModalOpen,
  handleCancel,
  currentPage,
  pageSize,
}) {
  const [isLoadCreate, setIsLoadCreate] = useState(false);
  const [formRef] = Form.useForm();

  const { user, allUser, isLoadAllUser } = useSession();
  const isAdmin = user?.data?.type === "ADMIN";
  const user_ids = allUser?.data?.map((item) => {
    return {
      value: item.id,
      label: getDisplayNameFromUser(item, item.username),
    };
  });

  useEffect(() => {
    // Chỉ ADMIN cần chọn chủ sở hữu; SHOP tự tạo cho chính mình (BE tự gán)
    if (isAdmin) {
      loadAllUser().catch(() => {});
    }
  }, [isAdmin]);


  // Xử lý khi nhấn nút "Thêm"
  const onFinish = async (fieldsValue) => {
    const values = { ...fieldsValue };
    setIsLoadCreate(true);

    try {
      const response = await store.dispatch(createTrademark(values));
      if (createTrademark.fulfilled.match(response)) {
        if (response.payload.data.original) {
          message.error(response.payload.data.original.message);
        } else {
          message.success("Thêm thương hiệu thành công");
          formRef.resetFields();
          handleCancel();
          await store.dispatch(
            getListTrademark({ currentPage, pageSize })
          );
        }
      } else if (createTrademark.rejected.match(response)) {
        handleErrors(response);
      }
    } catch (error) {
      message.error("Đã xảy ra lỗi khi tạo thương hiệu.");
    } finally {
      setIsLoadCreate(false);
    }
  };

  // Hàm xử lý lỗi từ API
  const handleErrors = (response) => {
    if (response.payload.errors) {
      Object.keys(response.payload.errors).forEach((field) => {
        const errorMessages = response.payload.errors[field];
        errorMessages.forEach((errorMessage) => {
          message.error(errorMessage);
        });
      });
    } else if (response.payload.message) {
      message.error(response.payload.message);
    }
  };


  return (
    <div>
      <Modal
        title="Thêm thương hiệu"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={600}
      >
        <Form
          name="addTradeMark"
          form={formRef}
          onFinish={onFinish}
          layout="vertical"
          requiredMark=""
        >
          <Row>
            <Col span={24}>
              <Form.Item
                label="Tên thương hiệu"
                name="name"
                rules={[{ required: true }]}
              >
                <Input placeholder="Nhập tên thương hiệu" />
              </Form.Item>

              {isAdmin && (
                <Form.Item
                  label="Tài khoản"
                  name="auth_user_id"
                  rules={[{ required: true, message: "Vui lòng chọn tài khoản" }]}
                >
                  <Select
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    filterSort={(optionA, optionB) =>
                      optionA?.label
                        ?.toLowerCase()
                        .localeCompare(optionB?.label?.toLowerCase())
                    }
                    disabled={isLoadAllUser}
                    placeholder="Vui lòng chọn khách hàng"
                    options={user_ids}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>



          <Divider />
          <Row>
            <Col span={24} style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                icon={<PlusCircleOutlined />}
                loading={isLoadCreate}
                style={{ minWidth: 150 }}
              >
                Thêm thương hiệu
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
}
